import { useLocalStorage } from "@uidotdev/usehooks"

import { User } from "__generated__/graphql"

export default function useMe() {
  const [me, setMe] = useLocalStorage<User | undefined>("me_user")

  return {
    me,
    setMe
  }
}
